/// Lets developers and testers log in with a pasted Onecta access token,
/// outside the Onecta app. See pages/developer/access-token.vue.
/// Only active when DEVELOPER_TOKEN_PAGE=true in the .env file of the environment.

const STORAGE_KEY = 'developer-access-token'

export const isDeveloperTokenPageEnabled = () =>
  process.env.developerTokenPage === true

/// Sets the token where the Onecta app puts it. middleware/access-token.js
/// detects the change and starts the login.
const applyAccessToken = (accessToken) => {
  window.unifiedApp = { ...(window.unifiedApp || {}), accessToken }
}

export const setDeveloperAccessToken = (accessToken) => {
  applyAccessToken(accessToken)
  try {
    window.sessionStorage.setItem(STORAGE_KEY, accessToken)
  } catch (err) {
    // Without session storage the token is lost on reload, but the login still works
  }
}

export const clearDeveloperAccessToken = () => {
  if (window.unifiedApp) {
    window.unifiedApp.accessToken = null
  }
  try {
    window.sessionStorage.removeItem(STORAGE_KEY)
  } catch (err) {
    // Nothing to clear
  }
}

export default function() {
  if (!isDeveloperTokenPageEnabled()) return
  // The developer page starts a new login, so do not restore the old token there.
  // Restoring it would make middleware/access-token.js log in and leave the page.
  if (
    window.location.pathname.replace(/\/$/, '') === '/developer/access-token'
  ) {
    clearDeveloperAccessToken()
    return
  }
  // A token from the Onecta app always wins
  if (window.unifiedApp?.accessToken) return

  let accessToken = null
  try {
    accessToken = window.sessionStorage.getItem(STORAGE_KEY)
  } catch (err) {
    return
  }
  if (accessToken) {
    applyAccessToken(accessToken)
  }
}
